import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init($element) {
  },
  finalize($element) {
    if ($element.find('.home-statistics')) {
      //gsap scrolltrigger functionality used to animate datepoints on homepage
      // const statItems = document.querySelectorAll('.home-statistics .statistic-item');
      const statItems = $element.find('.statistic-item').get();

      gsap.fromTo(statItems, {
          autoAlpha: 0, 
          y: 10,
          }, {
          scrollTrigger: {
          trigger: statItems,
          start: 'top bottom',
          once: true,
          },
          duration: .6, 
          autoAlpha: 1, 
          y: 0,
          stagger: .2,
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/home/statistics.js